import styled from '@emotion/styled';
import { OL_COLOUR_BLACK_55_HEX } from '../../../../../components/Style/colours';

import { MIXIN_ANCHOR_BUTTON } from '../../../../../components/Style/mixins';

export const CoursesAssignedWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const CourseAssignedItem = styled('div')({
  display: 'flex',
  ':not(:last-child)': {
    marginBottom: 20,
  },
});

export const LoadMoreButton = styled('button')({
  ...MIXIN_ANCHOR_BUTTON,
  margin: '20px auto 0',
  display: 'block',
});

export const CourseAssignedItemBody = styled('div')({
  marginLeft: 10,
});

export const CourseImage = styled('img')({
  width: 46,
  height: 40,
});

export const CourseName = styled('div')({
  fontWeight: 600,
  maxWidth: 300,
});

export const CoursePath = styled('div')({
  color: OL_COLOUR_BLACK_55_HEX,
});

export const CoursesSpinnerWrapper = styled('div')({
  textAlign: 'center',
});
